import { render, staticRenderFns } from "./index3Dian5.vue?vue&type=template&id=665e2bc2&scoped=true"
import script from "./index3Dian5.vue?vue&type=script&lang=js"
export * from "./index3Dian5.vue?vue&type=script&lang=js"
import style0 from "./index3Dian5.vue?vue&type=style&index=0&id=665e2bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665e2bc2",
  null
  
)

export default component.exports